import { createFileRoute } from "@tanstack/react-router";
import { ExerciseLayout } from "@/components/exercise-layout";

export const Route = createFileRoute("/train")({
  component: () => <ExerciseLayout id="train" />,
});
